import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {MatCardContent, MatCardModule} from "@angular/material/card";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonModule} from "@angular/material/button";
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatError, MatFormField, MatFormFieldModule} from "@angular/material/form-field";
import {FormsModule, NgForm, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule} from "@angular/material/icon";
import {ColorPickerModule} from "ngx-color-picker";
import {MatRadioModule} from "@angular/material/radio";
import {MatDividerModule} from "@angular/material/divider";
import {LockersService} from '../../../apis/services/lockers.service';
import {TenantType} from '../../../apis/enums/tenantType.enum';
import {CommonHelpers} from '../../../helpers/common.helper';
import {MatOption} from '@angular/material/core';
import {MachineType} from '../../../apis/enums/machineType.enum';
import {LockerStatus} from '../../../apis/enums/lockerStatus.enum';
import {LocationLocker} from '../../../apis/models/locationLocker';
import {LockerDetailWIB} from '../../../apis/models/lockerDetailsWIB';
import {LockerDetailMGT} from '../../../apis/models/lockerDetailsMGT';
import {MatSelect} from '@angular/material/select';
import {CommonModule} from '@angular/common';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {UserLoadSelect, UserService} from '../../../apis/services/user.service';
import {UserTypeEnum} from '../../../apis/enums/userType.enum';
import {ErrorDetail} from '../../../apis/models/errors';


interface LockerFull {
  IDLockerRacc: number,
  username?: string,
  password?: string,
  tenantType: TenantType,
  actualID?: number,
  serverAddress?: string,
  ip_address_server?: string,
  port_server?: string,
  machineType?: MachineType,
  serial_number?: string,
  lockerStatus: LockerStatus,
  notes?: string,
  location: LocationLocker,
  idLockerAccount?: number
  apiKey?: string
}


@Component({
  selector: 'locker-details',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    CommonModule,
    MatCardModule,
    MatMenuModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormField, MatOption, MatSelect,
    FormsModule, MatFormFieldModule,
    MatInputModule, MatIconModule,
    ReactiveFormsModule, ColorPickerModule,
    MatCardContent,
    MatRadioModule, MatDividerModule,
    MatError
  ],
  templateUrl: './locker-details.component.html',
  styleUrl: './locker-details.component.scss'
})
export class LockerDetailsComponent implements OnInit{

  isNewLocker: boolean = true;
  accountType: string = "LOCKER_MGT" as UserTypeEnum;
  userList: UserLoadSelect[] = [];
  errors: ErrorDetail[] = [];

  locker: LockerFull = {
    IDLockerRacc: 0,
    tenantType: TenantType.MGT,
    actualID: 1,
    machineType: MachineType.LOCKER,
    serverAddress: '',
    lockerStatus: 'PENDING' as LockerStatus,
    location: {
      address: ''
    }
  }

  protected readonly lockerTypes = Object.keys(TenantType).filter(key => isNaN(Number(key)));

  constructor(
    private lockersService: LockersService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private commonHelpers: CommonHelpers,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    const lockerID = this.route.snapshot.paramMap.get('id');
    if (lockerID) {
      this.lockersService.getLockerById(Number(lockerID)).subscribe(locker => {
          if (locker) {
            this.isNewLocker = false;
            this.locker = locker as LockerFull
            if(!this.locker.location){
              this.locker.location = {
                address: ''
              }
            }
            this.updateAccountTypeBasedOnTenant();
          } else {
            this.commonHelpers.openSnackBar("Nessun Locker trovato!", 'x', 4);
            this.router.navigate(['/lockers']);
          }
      })

    }

  }

  onSubmitForm(lockerForm: NgForm){
    let locker : LockerDetailMGT | LockerDetailWIB;
    if(this.locker.tenantType === TenantType.WIB){
      locker = this.locker as LockerDetailWIB
    } else {
      locker = this.locker as LockerDetailMGT
    }
    if (lockerForm.valid) {
        this.lockersService.updateLocker(locker).subscribe((response: any) => {
            if (response && response && response.status == 'success') {
                this.router.navigate(['/lockers']);
            } else {
              this.errors = response.listErrors;
              this.markAllAsTouched(lockerForm);
              this.commonHelpers.openSnackBar("Si è verificato un errore", 'x', 4);
            }
        })
    }
  }

  getEnumDescription(type: string): string {
    return TenantType[type as keyof typeof TenantType];
  }

  checkTenantType(){
    if(this.locker.tenantType === TenantType.WIB){
      return true
    }
    return false
  }

  openRefreshDialog(IDLocker: number): void {
    const dialogRef = this.dialog.open(LockerDeleteDialog, {});
    dialogRef.afterClosed().subscribe(result => {
        if(result){
            this.refreshLocker(IDLocker)
        }
    });
  }

  refreshLocker(IDLocker: number){
    console.log('Refresh Locker with ID: ' + IDLocker)
  }

  protected readonly LockerStatus = LockerStatus;

  configureLocker() {
    this.lockersService.configureLocker(this.locker.IDLockerRacc).subscribe({
      next: (result) => {
        if (result.configured === true) {
          this.commonHelpers.openSnackBar("Configurazione andata a buon fine", "x", 5);
          this.locker.lockerStatus = "CONFIGURED" as LockerStatus;
        } else {
          this.commonHelpers.openSnackBar("Configurazione fallita", "x", 5);
        }
      }
    });
  }

  getLockerStatusDescription(status: string): string {
    return LockerStatus[status as keyof typeof LockerStatus];
  }

  updateAccountTypeBasedOnTenant() {
    switch (this.locker.tenantType) {
      case TenantType.WIB:
        this.accountType = "LOCKER_WIB" as UserTypeEnum;
        break;
      case TenantType.MGT:
        this.accountType = "LOCKER_MGT" as UserTypeEnum;
        break;
      default:
        this.accountType = "LOCKER_MGT" as UserTypeEnum;  // Default case
        break;
    }
    this.userService.loadSelect(this.accountType).subscribe(
      (response) => {
        if (response.status === 'success') {
          this.userList = response.values;
        } else {
          this.commonHelpers.openSnackBar("Errore nel caricamento della lista utenti", 'x', 4);
        }
      },
      (error) => {
        this.commonHelpers.openSnackBar("Si è verificato un errore nella richiesta", 'x', 4);
      }
    );
  }

  isFieldInvalid(fieldName: string): boolean {
    return this.errors.some(error => error.fieldID == fieldName);
  }

  private markAllAsTouched(form: NgForm) {
    Object.values(form.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  removeFromErrors(idLockerAccount: string) {
    this.errors = this.errors.filter(e => e.fieldID != idLockerAccount)
  }
}

@Component({
    selector: 'refresh-locker-dialog',
    templateUrl: 'refresh-locker-dialog.component.html',
    imports: [
        MatFormFieldModule,
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
    ],
    standalone: true
})
export class LockerDeleteDialog {
  constructor(public dialogRef: MatDialogRef<LockerDeleteDialog>) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
